export function endpointRequireToken (url, method) {
  if (!url) {
    return true
  }
  const reLoginRefresh = /[/]?login\/refresh[/]?/
  const reLogin = /[/]?login[/]?$/
  const reLoginAd = /[/]?login\/login-ldap[/]?/
  const reAccActivation = /[/]?security\/users\/.+\/activate/
  const reAccValidateActivationToken = /[/]?security\/users\/activation-token-validate/
  const reAccValidateResetToken = /[/]?security\/users\/reset-token-validate/

  const reDocumentSecurity = /[/]?projects\/documents\/.+\/security/
  // TODO
  const reAccReset = /[/]?security\/users\/password-reset/
  const reAccUserReset = /[/]?security\/users\/.+\/password-reset/
  const reBudgetUserAutocomplete = /[/]?registry\/organizations/
  const reOrganization = /[/]?security\/organizations/
  const test = !(reLogin.test(url) ||
    reLoginAd.test(url) ||
    reLoginRefresh.test(url) ||
    reAccActivation.test(url) ||
    reAccValidateActivationToken.test(url) ||
    reAccValidateResetToken.test(url) ||
    reAccReset.test(url) ||
    reAccUserReset.test(url) ||
    reBudgetUserAutocomplete.test(url) ||
    reDocumentSecurity.test(url) ||
    (reOrganization.test(url) && method === 'POST') ||
    (reOrganization.test(url) && method === 'PUT')
  )
  return test
}
